var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.2274 1.2274c.7029-.702941 1.8426-.702941 2.5456 0 .7029.70295.7029 1.84264 0 2.54559l-.7136.7136-2.5456-2.54558z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.24101 3.2138-7.540815 7.5408v2.5456h2.545585l7.54082-7.54082z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.00ded91682f1f731f258ec18eee7267b.svg";
export { ForwardRef as ReactComponent };